import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import SmoothCollapse from 'react-smooth-collapse'

import FormattedText from '../../../common/formatted-text'
import { AnswerPart, QuestionTexts } from './types'

type QuestionProps = QuestionTexts

const Item: React.FunctionComponent<QuestionProps> = ({ q, a }) => {
    const [hover, setHover] = useState(false)
    const [open, setOpen] = useState(false)

    const { i18n } = useTranslation('faq')

    const getAnswer = (el: AnswerPart, i: number) => {
        switch(el.type) {
            case 'text': {
                const text = el.content
                const lines = text.split('\n')

                return (
                    <Text key={i}>
                        {
                            lines.map((l, i) => [
                                <FormattedText text={l} key={i}/>,
                                <br />
                            ])
                        }
                    </Text>
                )
            }
            case 'verbatim_text': {
                const text = el.content
                const lines = text.split('\n')

                return (
                    <Text key={i}>
                        {
                            lines.map((l, i) => [
                                l,
                                <br />
                            ])
                        }
                    </Text>
                )
            }
            case 'image':
                const imageName = el.content
                const path = require(`./images/questions/${i18n.language}/${imageName}.png`)

                return <Image key={i} src={path}/>
            default:
                console.log('Cannot render', { el })
                return null
        }
    }
    

    return (
        <Container>
            <QuestionContainer 
                onClick={() => setOpen(!open)} 
                onMouseEnter={() => setHover(true)} 
                onMouseLeave={() => setHover(false)}
                onTouchStart={() => setHover(true)} 
                onTouchEnd={() => setHover(false)}
            >
                <Question hover={hover}>{q}</Question>
                <Icon src={require('./images/arrow.svg')} open={open} />
            </QuestionContainer>
            <SmoothCollapse expanded={open}>
                <Answer>
                    {
                        a.map((el, i) => getAnswer(el, i))
                    }
                </Answer>
            </SmoothCollapse>
        </Container>
    )
}


const Container = styled.div`
    display: grid;
    width: 100%;
    grid-template-columns: 1fr;

    border-bottom: 1px solid ${p => p.theme.colors.onceSeparatorFaq};
`

const QuestionContainer = styled.div`
    min-height: 76px;
    width: 100%;

    padding: 24px 0;

    display: grid;
    grid-template-columns: auto auto;

    align-items: center;
    justify-items: space-between;

    cursor: pointer;
`

const Question = styled.div<{hover: boolean}>`
    font-size: 16px;
    font-weight: 700;

    justify-self: flex-start;

    color: ${p => p.hover ? p.theme.colors.accent : p.theme.colors.main };
`

const Icon = styled.img<{open: boolean}>`
    margin: 32px;
    width: 12px;

    justify-self: flex-end;

    transform: rotate(${p => p.open ? '0deg' : '180deg'});
    transition: transform 300ms ease-out;
`

const Answer = styled.div`
    display: grid;

    font-size: 16px;
    line-height: 28px;

    padding-bottom: 24px;
`

const Text = styled.p`

`

const Image = styled.img`
    width: 280px;

    justify-self: center;

    margin: 15px 0;
`

export default Item